import type { TupleToUnion } from 'type-fest'

export type ProjectPageTab = 'details' | 'activity' | 'internal'

export type DashboardPageTab =
  | 'all'
  | 'draft'
  | 'submitted'
  | 'in-progress'
  | 'completed'
  | 'archived'
  | 'offers'
  | 'rejected'

export const settingsPageTabs = ['user-profile', 'agency-profile'] as const
export type SettingsPageTab = TupleToUnion<typeof settingsPageTabs>
